import React from 'react'


const Select = props => {

    const { items, placeholder, name, value, onChange } = props
    const array = Object.entries(items)
    const defaultValue = props.defaultValue ? props.defaultValue : ''
    
    return (
        <select
            name={name}
            value={value}
            defaultValue={defaultValue}
            onChange={onChange}
        >
            <option value='' disabled>{placeholder}</option>
            {
                array.map(item => {
                    return item ? <option key={item[0]} value={item[0]}>{item[1]}</option> : ''
                })
            }
        </select>
    )
}

export default Select;


// WEBPACK FOOTER //
// ./src/acervo/components/UI/Select/Select.js